import { z } from 'zod';
import { pagedSchema } from '@/shared/reference/wire';
const text = z.string().nullish();
const count = z.number().nullish();
const valuesRecord = z.record(z.string(), z.unknown());
export const auditUserSchema = z.looseObject({
  userId: text,
  tenantName: text,
  userIdDisplay: text.meta({ pii: 'name' }),
  userName: text.meta({ pii: 'name' }),
});
export const auditEntrySchema = z.looseObject({
  id: z.string(),
  action: z.string(),
  transactionId: text,
  recordType: text,
  recordTypeDisplay: text,
  recordId: text,
  currentValues: valuesRecord.nullish(),
  previousValues: valuesRecord.nullish(),
  additionalValues: valuesRecord.nullish(),
  currentValuesJson: text,
  previousValuesJson: text,
  additionalValuesJson: text,
  user: auditUserSchema.nullish(),
  userName: text.meta({ pii: 'name' }),
  origin: z.looseObject({ ip: text.meta({ pii: 'ip' }) }).nullish(),
  createdAt: z.string(),
});
export const auditListSchema = z.array(auditEntrySchema);
export const enumValueSchema = z.looseObject({
  name: z.string(),
  value: z.string(),
  valueAsInt: z.number(),
});
export const enumValueListSchema = z.array(enumValueSchema);
export const tenantOptionSchema = z.looseObject({ id: z.string(), name: z.string() });
export const tenantOptionListSchema = z.array(tenantOptionSchema);
export const bankOptionSchema = z.looseObject({
  code: z.number().nullish(),
  codeDisplay: text,
  name: text,
  ispb: count,
});
export const bankOptionPageSchema = pagedSchema(bankOptionSchema);
export const signedUploadSchema = z.looseObject({
  filename: z.string(),
  getUrl: z.string(),
  putUrl: z.string(),
  deleteURL: text,
  deteleURL: text,
});
export type AuditEntry = z.infer<typeof auditEntrySchema>;
export type EnumValue = z.infer<typeof enumValueSchema>;
export type SignedUpload = z.infer<typeof signedUploadSchema>;

export const cosifAccountSchema = z.looseObject({
  code: z.string(),
  description: z.string(),
  externalAccountId: text,
  tenantName: text,
  pix: z.boolean().nullish(),
  transfer: z.boolean().nullish(),
  bankSlip: z.boolean().nullish(),
});
export const cosifAccountListSchema = z.array(cosifAccountSchema);
export type CosifAccount = z.infer<typeof cosifAccountSchema>;
